var insert = require('insert-css');
var normalize = require('./normalize');

insert(normalize);



//////////////////
// WEBPACK FOOTER
// ./node_modules/normalize-css/index.js
// module id = ./node_modules/normalize-css/index.js
// module chunks = index